	function transmissao(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"O vírus pode ser transmitido  de um indivíduo infectado para uma pessoa saudável, e também através das mãos e objetos contaminados.",
						"title":"Como se pega a doença?",
						"image":"images/games/informs/transmissao/1.png",
					},
					{
						"text":"O indivíduo infectado pode liberar gotículas contaminadas ao falar. Estas gotículas, ao atingirem uma pessoa saudável, podem entrar pelos olhos, nariz ou boca, contaminando-a.",
						"title":"Como se pega a doença?",
						"image":"images/games/informs/transmissao/1.png",
					},
					{
						"text":"O vírus sobrevive de algumas horas até alguns dias em objetos. Por isso, superfícies possivelmente infectadas devem ser higienizadas com sabão ou álcool com frequência.",
						"title":"Como se pega a doença?",
						"image":"images/games/informs/transmissao/1.png",
					},
					{
						"text":"Até o momento, não existem evidências de transmissão do vírus de animais de estimação para humanos, apesar de alguns deles terem sido diagnosticados com a doença.",
						"title":"Como se pega a doença?",
						"image":"images/games/informs/transmissao/1.png",
					},
					{
						"text":"É recomendado manter contato limitado com animais se estiver doente.",
						"title":"Como se pega a doença?",
						"image":"images/games/informs/transmissao/1.png",
					}
					
				],
				"pathImageGame":"midias/images/games/puzzles/transmissao/1.png"
			}
		]
	};
}

export {transmissao};
